export default "__VITE_ASSET__BStVqmu2__"